import React from 'react';
import { IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  NotificationDialog,
  NotificationDialogActions,
  NotificationDialogContent,
  NotificationDialogDescription,
  NotificationDialogTitle,
} from '@shiftfinancial/design-system';
import CloseIcon from '../svg/CloseIcon';
import WarningIcon from '../svg/WarningIcon';

const useStyles = makeStyles((theme) => ({
  warningIcon: {
    width: '80px',
    height: '80px',
    margin: theme.spacing(0, 0, 2, 0),
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[800],
  },
  dialogTitle: {
    textAlign: 'center',
  },
}));

type DialogProps = {
  description: string;
  title: string;
  openState: any;
  onConfirm: () => void;
};

const Dialog = (props: DialogProps) => {
  const { description, title, openState, onConfirm } = props;
  const classes = useStyles();

  return (
    <NotificationDialog open={openState.isOpen} onClose={openState.close}>
      <NotificationDialogContent appearance='warning' data-testid='uia-confirm-dialog-content' icon={<WarningIcon className={classes.warningIcon} />}>
        <IconButton aria-label='close' data-testid='uia-confirm-close-button' className={classes.closeButton} onClick={openState.close}>
          <CloseIcon />
        </IconButton>
        <NotificationDialogTitle className={classes.dialogTitle}>{title}</NotificationDialogTitle>
        <NotificationDialogDescription>
          <Typography variant='body2' component='span'>
            {description}
          </Typography>
        </NotificationDialogDescription>
        <NotificationDialogActions aria-expanded={true}>
          <Button appearance='primary' data-testid='uia-confirm-dialog-button' onClick={onConfirm}>
            Confirm
          </Button>
          <Button appearance='secondary' data-testid='uia-dismiss-dialog-button' onClick={openState.close}>
            Dismiss
          </Button>
        </NotificationDialogActions>
      </NotificationDialogContent>
    </NotificationDialog>
  );
};

export default Dialog;
